import { render, staticRenderFns } from "./ReportCenterTable.vue?vue&type=template&id=c772e6e6&scoped=true"
import script from "./ReportCenterTable.vue?vue&type=script&lang=js"
export * from "./ReportCenterTable.vue?vue&type=script&lang=js"
import style0 from "./ReportCenterTable.vue?vue&type=style&index=0&id=c772e6e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c772e6e6",
  null
  
)

export default component.exports